// Reporter Agent — action types + creators

export const TRIGGER_REPORTER_RUN_REQUEST = "TRIGGER_REPORTER_RUN_REQUEST";
export const TRIGGER_REPORTER_RUN_SUCCESS = "TRIGGER_REPORTER_RUN_SUCCESS";
export const TRIGGER_REPORTER_RUN_FAILURE = "TRIGGER_REPORTER_RUN_FAILURE";

export const RESET_REPORTER_STATE = "RESET_REPORTER_STATE";

export const triggerReporterRunRequest = (payload) => ({ type: TRIGGER_REPORTER_RUN_REQUEST, payload });
export const triggerReporterRunSuccess = (result)  => ({ type: TRIGGER_REPORTER_RUN_SUCCESS, payload: result });
export const triggerReporterRunFailure = (error)   => ({ type: TRIGGER_REPORTER_RUN_FAILURE, error });

export const resetReporterState = () => ({ type: RESET_REPORTER_STATE });
